import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    formData: {
        implement_interim_containment_action: '',
        implement_interim_containment_action_other: '',
        escape_point: '',
        ndrc_identification: '',
        corrective_actions_ndrc: '',
        process_root_cause_description: '',
        process_root_cause_identification: '',
        corrective_actions_process_root_cause: '',
        system_root_cause_identification: '',
        corrective_actions_system_root_cause: '',
        preventive_action_plan: null,
        preventive_action_implementation_timeline: null,
        action_attachments: '',
        action_attachments_file_name: '',
    },
    isLoading: false
};

const actionFormSlice = createSlice({
    name: 'actionForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.formData = { ...state.formData, ...action.payload };
        },
        setLoading: (state,action) => {
            state.isLoading = action.payload || false;
        },
        resetFormData: (state) => {
            state.formData = {
                ...state?.formData,
                implement_interim_containment_action: '',
                implement_interim_containment_action_other: '',
                escape_point: '',
                ndrc_identification: '',
                corrective_actions_ndrc: '',
                process_root_cause_identification: '',
                corrective_actions_process_root_cause: '',
                system_root_cause_identification: '',
                corrective_actions_system_root_cause: '',
                preventive_action_plan: null,
                preventive_action_implementation_timeline: null,
                action_attachments: '',
                action_attachments_file_name: '',
            }
        }
    }
});

export const {
    setFormData,
    setLoading,
    resetFormData
} = actionFormSlice.actions;

export const fetchFormData = (ncrId, accessToken, refresh = false) => async (dispatch) => {
    if (!refresh) {
        dispatch(setLoading(true));
    }
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/forms/${ncrId}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        dispatch(setFormData(response.data.ncrForm));
    } catch (error) {
        console.log(error.response.data.message);
    }finally {
        dispatch(setLoading(false));
    }
};

export default actionFormSlice.reducer;